// Angular
import { ChangeDetectorRef, Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

// Libraries
import { finalize, takeUntil, tap } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

// Services
import { CoreService } from '../../../../shared/services';

// Auth
import { AuthService } from '../..';
import { AppCleanup } from '../../../../shared/models';

// Enums
import { StatusType } from '../../../../shared/enums';

// Helpers
import { FormHelper } from '../../../../shared/helpers/form.helper';

@Component({
	selector: 'forgot-password',
	templateUrl: './forgot-password.component.html',
	styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent extends AppCleanup implements OnInit, OnDestroy {
	@HostBinding('class') classes = 'component-container';
	form: FormGroup;
	loading = false;
	errors: any = [];

	constructor(
		private authService: AuthService,
		private translateService: TranslateService,
		private router: Router,
		private formBuilder: FormBuilder,
		private cdr: ChangeDetectorRef,
		private coreService: CoreService
	) {
		super();
	}

	ngOnInit() {
		this.initRegistrationForm();
	}

	ngOnDestroy() {
		this.loading = false;
		super.ngOnDestroy();
	}

	/**
	 * Form initalization
	 * Default params, validators
	 */
	initRegistrationForm() {
		this.form = this.formBuilder.group({
			email: [
				'',
				Validators.compose([
					Validators.required,
					Validators.email,
					Validators.minLength(3),
					Validators.maxLength(320), // https://stackoverflow.com/questions/386294/what-is-the-maximum-length-of-a-valid-email-address
				]),
			],
		});
	}

	submit() {
		const controls = this.form.controls;
		/** check form */
		if (this.form.invalid) {
			Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
			return;
		}

		this.loading = true;

		const email = controls.email.value;
		this.authService
			.requestPassword(email)
			.pipe(
				tap((response) => {
					if (response) {
						const message = this.translateService.instant('MODULE.AUTH.FORGOT.SUCCESS');
						this.coreService.toast({ message: message, type: StatusType.SUCCESS });
						this.router.navigateByUrl('/auth/login');
					} else {
						const message = this.translateService.instant('MODULE.AUTH.VALIDATION.NOT_FOUND', { name: this.translateService.instant('MODULE.AUTH.INPUT.EMAIL') });
						this.coreService.toast({ message: message, type: StatusType.DANGER });
					}
				}),
				takeUntil(this.destroy),
				finalize(() => {
					this.loading = false;
					this.cdr.markForCheck();
				})
			)
			.pipe(takeUntil(this.destroy))
			.subscribe();
	}

	controlHasError(controlName: string, validationType: string): boolean {
		return FormHelper.controlHasError(this.form, controlName, validationType);
	}
}
